import DialogTitle from '@mui/material/DialogTitle';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { X } from '../../../../icons/x';
import STRING_KEYS from '../../../../language/keys';
import { DialogStyle } from './style';

type NewTalentDialogHeaderProps = {
  onCloseClick: () => void,
}
  
export default function NewTalentDialogHeader({ onCloseClick }
  :NewTalentDialogHeaderProps): JSX.Element {
  const { t: translate } = useTranslation();

  return (
    <DialogTitle
      style={ DialogStyle.dialogTitle.style }
      sx={ DialogStyle.dialogTitle.sx }
    >
      <Typography>{translate(STRING_KEYS.TALENTS_PAGE_CREATE_BUTTON)}</Typography>
      <X
        style={ DialogStyle.close }
        onClick={ onCloseClick }
      />
    </DialogTitle>
  );
}
